import React, { useContext } from "react";
import { FaCheckCircle, FaTimesCircle, FaDownload, FaCalendarAlt } from "react-icons/fa";
import { MdError } from "react-icons/md";
import searchDocContext from "../context/searchDocument/searchDocContext";

export default function SearchFieldResult() {
  const { foundedSearchDoc, showError, handleDownload, startLoading } = useContext(searchDocContext);

  // Loading state
  if (startLoading) return null; // InputTextField handles loading state

  // Validation / API error
  if (showError) {
    return (
      <div className="vp-result vp-result--error">
        <MdError className="vp-result__icon" />
        <div className="vp-result__body">
          <h3 className="vp-result__title">Verification Failed</h3>
          <p className="vp-result__msg">{showError}</p>
        </div>
      </div>
    );
  }

  // No search done yet
  if (!foundedSearchDoc) return null;

  const cert = foundedSearchDoc?.certification;
  const isVerified = foundedSearchDoc.success === true;
  const isExpired = cert?.is_expired === true;

  if (isVerified && cert) {
    return (
      <div className={`vp-result ${isExpired ? "vp-result--invalid" : "vp-result--success"}`}>
        {/* Header */}
        <div className="vp-result__header">
          {isExpired ? (
            <FaTimesCircle className="vp-result__icon vp-result__icon--invalid" />
          ) : (
            <FaCheckCircle className="vp-result__icon vp-result__icon--success" />
          )}
          <div>
            <h3 className="vp-result__title">
              {isExpired ? "Certificate Expired" : "Certificate Verified"}
            </h3>
            <p className="vp-result__subtitle">
              {cert.message || "This document is authentic and issued by TUV PAK Inspection Services."}
            </p>
          </div>
        </div>

        {/* Details grid */}
        <div className="vp-result__details">
          {cert.expire_date && (
            <div className="vp-result__detail-item">
              <FaCalendarAlt className="vp-result__detail-icon" />
              <div>
                <span className="vp-result__detail-label">Expiry Date</span>
                <span className="vp-result__detail-value">{cert.expire_date}</span>
              </div>
            </div>
          )}
        </div>

        {/* Download */}
        {!isExpired && cert.certification_url && (
          <button className="vp-result__download" onClick={handleDownload}>
            <FaDownload />
            Download Certificate
          </button>
        )}

        <p className="vp-result__footer-note">
          Verified by TUV PAK Inspection Services · <a href="https://tuvpak.com/" target="_blank" rel="noreferrer">tuvpak.com</a>
        </p>
      </div>
    );
  }

  // Not verified
  return (
    <div className="vp-result vp-result--invalid">
      <div className="vp-result__header">
        <FaTimesCircle className="vp-result__icon vp-result__icon--invalid" />
        <div>
          <h3 className="vp-result__title">Certificate Not Found</h3>
          <p className="vp-result__subtitle">
            No valid certificate was found for this ID. Please check the ID and try again.
          </p>
        </div>
      </div>
      <p className="vp-result__contact">
        If you believe this is an error, please contact TUV PAK directly at{" "}
        <a href="https://tuvpak.com/" target="_blank" rel="noreferrer">tuvpak.com</a>.
      </p>
    </div>
  );
}
